import ApiService from "@/core/services/api.service";

// action types
export const UPDATE_SIGN_INS = "updateSignIns";
export const SWITCH_PAGE = "switchPage";

// mutation types
export const SET_SIGN_INS = "setSignIns";
export const SET_SIGN_INS_PAGINATION = "setSignInsPagination";

const state = {
  signIns: {},
  signInsPagination: {
    path: 0,
    perPage: 1,
    nextPageUrl: 1,
    prevPageUrl: 1
  }
};

const getters = {
  signIns(state) {
    return state.signIns;
  },
  signInsPagination(state) {
    return state.signInsPagination;
  }
};

const actions = {
  [UPDATE_SIGN_INS](context) {
    return new Promise((resolve, reject) => {
      ApiService.get("sign-ins")
        .then(({ data }) => {
          context.commit(SET_SIGN_INS, data["data"]);
          context.commit(SET_SIGN_INS_PAGINATION, {
            path: data["path"],
            perPage: data["per_page"],
            nextPageUrl: data["next_page_url"],
            prevPageUrl: data["prev_page_url"]
          });

          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [SWITCH_PAGE](context, type) {
    return new Promise((resolve, reject) => {
      let url =
        type === "next"
          ? context.state.signInsPagination.nextPageUrl
          : context.state.signInsPagination.prevPageUrl;

      ApiService.query("sign-ins", {
        params: {
          cursor: url.replace(
            context.state.signInsPagination.path + "?cursor=",
            ""
          )
        }
      })
        .then(({ data }) => {
          context.commit(SET_SIGN_INS, data["data"]);
          context.commit(SET_SIGN_INS_PAGINATION, {
            path: data["path"],
            perPage: data["per_page"],
            nextPageUrl: data["next_page_url"],
            prevPageUrl: data["prev_page_url"]
          });
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  }
};

const mutations = {
  [SET_SIGN_INS](state, data) {
    state.signIns = data;
  },
  [SET_SIGN_INS_PAGINATION](state, data) {
    state.signInsPagination = data;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
